import { Controller } from "@hotwired/stimulus"

// Expands the read-only subtask preview under a task row on the site page. Unlike
// collapsible_section_controller.js nothing is remembered: every row starts collapsed, also when
// Turbo restores a cached snapshot of an expanded page (back button), because connect() resets it.
export default class extends Controller {
  static targets = ["toggle", "panel", "icon"]

  connect() {
    this.apply(false)
  }

  toggle() {
    this.apply(this.panelTarget.classList.contains("hidden"))
  }

  apply(expanded) {
    this.panelTarget.classList.toggle("hidden", !expanded)
    if (this.hasIconTarget) this.iconTarget.classList.toggle("rotate-90", expanded)

    const label = expanded
      ? this.toggleTarget.dataset.labelCollapse
      : this.toggleTarget.dataset.labelExpand
    this.toggleTarget.setAttribute("aria-expanded", String(expanded))
    if (label) {
      this.toggleTarget.setAttribute("aria-label", label)
      this.toggleTarget.setAttribute("title", label)
    }
  }
}
